import { z } from 'zod';

import { ExternalLoanIdRecordId, ExternalLoanIdValue, LoanId } from '../BrandedIds';

export const ExternalLoanIdType = z.enum([
  'ownerId',
  'ownerLoanId',
  'poolId',
  'previousServicerId',
  'capitalPartnerId',
  'fullId',
  'otherId1',
  'otherId2',
  'otherId3',
]);
export type ExternalLoanIdType = z.infer<typeof ExternalLoanIdType>;

export interface ExternalLoanIdRecord {
  recordId: ExternalLoanIdRecordId;
  value: ExternalLoanIdValue;
  loanId: LoanId;
  type: ExternalLoanIdType;
  hidden: boolean;
  startDate: Date;
  soldDate?: Date;

  createdAt: Date;
  updatedAt: Date;
}

// Point in time snapshot of external loan ids
export type ExternalLoanIdSnapshot = Record<ExternalLoanIdType, string | undefined>;
